<template>
  <div class="staff">
    <CreateOrEditStaff ref="createOrEditDialog" @submitDialog="GetTableList" />

    <div class="PageHeader">
      <el-breadcrumb>
        <el-breadcrumb-item> {{l("员工管理")}} </el-breadcrumb-item>
      </el-breadcrumb>
      <div class="HeaderButtons">
        <el-button
          v-if="$store.getters.checkPermission('staff.add')"
          type="primary"
          icon="el-icon-plus"
          size="small"
          @click="CreateItem()"
          >{{l("邀请子账号")}}</el-button
        >
      </div>
    </div>
    <div class="PageContent">
      <el-row class="TableSearchRow" type="flex" :gutter="20">
        <el-col :span="6">
          <label>{{l("昵称")}}</label>
          <el-input
            :placeholder="l('请输入') + l('内容')"
            v-model="SearchData.name"
            clearable
            @clear="GetTableList(true)"
            @keyup.enter.native="GetTableList(true)"
          ></el-input>
        </el-col>
        <el-col :span="6">
          <label>{{l("手机号")}}</label>
          <el-input
            :placeholder="l('请输入') + l('内容')"
            v-model="SearchData.mobile"
            clearable
            @clear="GetTableList(true)"
            @keyup.enter.native="GetTableList(true)"
          ></el-input>
        </el-col>
        <el-col :span="4">
          <el-button
            type="primary"
            icon="el-icon-search"
            round
            @click="GetTableList(true)"
            >{{l("查询")}}</el-button
          >
        </el-col>
      </el-row>

      <el-table
        :data="TableList"
        :stripe="true"
        @selection-change="HandleSelectionChange"
        @sort-change="HandleSortChange"
      >
        <!-- 不能移除和转让自己 -->
        <TableOperation
          v-if="$store.getters.checkPermission('staff.edit')"
          :operationList="[
            {
              is_show: (row) => !row.is_main,
              label: l('移除'),
              command: 'unbindItem',
            },
            {
              is_show: (row) => !row.is_main,
              label: l('转让'),
              command: 'transferItem',
            },
          ]"
          @handleOperation="HandleOperation"
        />

        <el-table-column :label="l('账户角色')" show-overflow-tooltip>
          <template slot-scope="scope">
            <div v-if="scope.row.is_main">{{l("主账户")}}</div>
            <div v-else>{{l("子账号")}}</div>
          </template>
        </el-table-column>

        <el-table-column prop="mobile" :label="l('账号')"></el-table-column>

        <el-table-column :label="l('头像')">
          <template slot-scope="scope">
            <div class="ImageInTable">
              <el-image
                v-if="scope.row.avatar"
                :src="scope.row.avatar"
                fit="contain"
                :preview-src-list="[scope.row.avatar]"
              ></el-image>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="display_name"
          :label="l('昵称')"
          show-overflow-tooltip
        ></el-table-column>

        <el-table-column prop="created_time" :label="l('注册日期')" sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.created_time.slice(0, 10) }}
          </template>
        </el-table-column>
        <!-- 
        <el-table-column
          prop="last_login"
          label="最近登录"
          width="170"
        ></el-table-column> -->
      </el-table>
      <el-pagination
        background
        @size-change="HandleSizeChange"
        @current-change="HandleCurrentChange"
        :current-page="CurrentPage"
        :page-sizes="PageSizeList"
        :page-size="PageSize"
        layout="total, prev, pager, next, jumper"
        :total="TotalCount"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import tableMixin from "@/assets/js/tableMixin";
import CreateOrEditStaff from "./operation/CreateOrEditStaff.vue";

export default {
  name: "Staff",
  components: {
    CreateOrEditStaff,
  },
  mixins: [tableMixin],
  data() {
    return {
      SearchData: {
        name: "",
        mobile: "",
      },
    };
  },
  methods: {
    GetTableList(resetPage) {
      if (resetPage == true) this.CurrentPage = 1;

      this.axios
        .get("/api/staff/", {
          params: {
            ...this.SearchData,
            ordering: this.Sorting,
            size: this.PageSize,
            page: this.CurrentPage,
          },
        })
        .then((data) => {
          this.TotalCount = data.count;
          this.TableList = data.results;
        });
    },
    unbindItem(item) {
      this.$confirm(
        this.l(`该用户商品、需求及询报价等信息将转移给主账户`),
        `${this.l("是否移除")}【${item.display_name}】?`,
        {
          type: "warning",
        }
      ).then(() => {
        this.axios.put(`/api/staff/${item.id}/unbind/`).then((response) => {
          this.GetTableList();
        });
      });
    },

    transferItem(item) {
      this.$confirm(`${this.l("是否将")}${this.l("主账户身份转让给")}【${item.display_name}】?`, "", {
        type: "warning",
      }).then(() => {
        this.axios
          .put(`/api/staff/${item.id}/transfer/`, {
            user_id: item.id,
          })
          .then((response) => {
            this.$store.dispatch("updateSession").then(() => {
              this.$router.push({ path: "/backend" });
            });
          });
      });
    },
  },
};
</script>


<style scoped lang="scss">
</style>

